// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","App__content":"App_App__content__mAGIr"};